// src/redux/slices/tableAvailabilitySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TimeSlot, TableAvailabilityRequest, TableAvailabilityResponse } from '../../types/tableReservation';

interface TableAvailabilityState {
  items: any[];
  time_slots: TimeSlot[];
  loading: boolean;
  error: string | null;
  noTablesAvailable: boolean;
}

const initialState: TableAvailabilityState = {
  items: [],
  time_slots: [],
  loading: false,
  error: null,
  noTablesAvailable: true,
};

export const tableAvailabilitySlice = createSlice({
  name: 'tableAvailability',
  initialState,
  reducers: {
    // Async action triggers for table availability
    fetchTableAvailabilityRequest: (state, action: PayloadAction<TableAvailabilityRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchTableAvailabilitySuccess: (state, action: PayloadAction<TableAvailabilityResponse & { noTablesAvailable: boolean }>) => {
      state.items = action.payload.availableDetails;
      state.time_slots = action.payload.time_slots;
      state.noTablesAvailable = action.payload.noTablesAvailable;
      state.loading = false;
    },
    fetchTableAvailabilityFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchTableAvailabilityRequest,
  fetchTableAvailabilitySuccess,
  fetchTableAvailabilityFailure,
} = tableAvailabilitySlice.actions;

export default tableAvailabilitySlice.reducer;
